import HttpClient from "utils/HttpClient/HttpClient"
import {
    SUCCESSFUL_GET_QUOTASTOPAY,
    UPDATE_QUOTAS_SELECTION,
    UPDATE_MAKE_REQUEST_QUOTAS,
    UPDATE_SALE_ORDER,
    UPDATE_SELECTED_QUOTA_ID,
    UPDATE_PAYMENT_METHOD,
    GENERAL_UPDATE_QUOTAS_TO_PAY,
    UPDATE_ONLINE_PAYMENT_ID,
    UPDATE_DRAFT_SALEORDER_PAYMENT_TYPE,
    UPDATE_RESERVE_AMOUNT
} from "./actionConst";
import { SHOW_ERROR_MESSAGE } from 'reducers/application/actionConst';
import { RESERVE } from "../../constants/draftSaleOrderPaymentTypeConst";

export const fetchQuotasToPay = (saleOrderId, resolve) => dispatch => {
    if (saleOrderId == 0) {
        dispatch({
            type: SUCCESSFUL_GET_QUOTASTOPAY,
            payload: []
        });
        return;
    }
    new HttpClient(true).get("b2c/quotastopay",
        {
            params: {
                saleOrderId: saleOrderId
            }
        })
        .then((response) => {
            console.log("Successful Fetch QuotasToPay");
            dispatch({
                type: SUCCESSFUL_GET_QUOTASTOPAY,
                payload: response.data
            });
            resolve();
        })
        .catch((error) => {
            console.log("Failed Fetch QuotasToPay");
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.message
            });
        })
}

export const updateQuotaSelection = (quotaId) => dispatch => {
    dispatch({
        type: UPDATE_QUOTAS_SELECTION,
        payload: quotaId
    });
}

export const updateMakeRequestQuotas = (value) => dispatch => {
    dispatch({
        type: UPDATE_MAKE_REQUEST_QUOTAS,
        payload: value
    });
}

export const updateSaleOrderAtToPay = (saleOrder) => dispatch => {
    dispatch({
        type: UPDATE_SALE_ORDER,
        payload: saleOrder
    });
}

export const updateSelectedQuotaId = (quotaId) => dispatch => {
    dispatch({
        type: UPDATE_SELECTED_QUOTA_ID,
        payload: quotaId
    });
}

export const updatePaymentMethod = (paymentMethod, accountBalance) => dispatch => {
    dispatch({
        type: UPDATE_PAYMENT_METHOD,
        payload: { paymentMethod: paymentMethod, accountBalance: accountBalance }
    });
}

export const updateGeneralUpdateQuotasToPay = (object) => dispatch => {
    dispatch({
        type: GENERAL_UPDATE_QUOTAS_TO_PAY,
        payload: object
    });
}

export const updateOnlinePaymentId = (onlinePaymentId) => dispatch => {
    dispatch({
        type: UPDATE_ONLINE_PAYMENT_ID,
        payload: onlinePaymentId
    });
}

export const updateDraftSaleOrderPaymentType = (paymentType, saleOrderId) => dispatch => {
    let payload = {
        paymentType: paymentType,
        reserveAmount: 0
    }
    if (saleOrderId != 0 && paymentType === RESERVE) {
        new HttpClient(true).get("b2c/saleorders/reserve_amount",
            {
                params: {
                    saleOrderId: saleOrderId
                }
            })
            .then((response) => {
                console.log("Successful Fetch Min Reserve Amount");
                const minReserve = response.data.value;
                payload.reserveAmount = minReserve;
                dispatch({
                    type: UPDATE_RESERVE_AMOUNT,
                    payload: minReserve
                });
                dispatch({
                    type: UPDATE_DRAFT_SALEORDER_PAYMENT_TYPE,
                    payload: payload
                });
            })
            .catch((error) => {
                dispatch({
                    type: SHOW_ERROR_MESSAGE,
                    payload: error.message
                });
            })
    } else {
        dispatch({
            type: UPDATE_DRAFT_SALEORDER_PAYMENT_TYPE,
            payload: payload
        });
    }

}



// WEBPACK FOOTER //
// ./src/reducers/quotastopay/quotastopayActions.js